import { useQuery } from "@tanstack/react-query";

import { parseShopHandle } from "./shopifyStore";
import { useTRPC } from "./trpc";

/**
 * The environment's Shopify link as every Shopify page reads it: one `shopify.status` query,
 * shared by the layout and its sections, so a section costs no extra request.
 */
export function useShopifyShop() {
  const trpc = useTRPC();
  const status = useQuery(trpc.shopify.status.queryOptions());
  const shop = status.data?.shop ?? null;
  return {
    status,
    shop,
    linked: shop?.status === "active",
    /** The store's admin handle, for links into Shopify; null when the domain does not parse. */
    shopHandle: shop ? parseShopHandle(shop.shopDomain) : null,
  };
}
